export function useFieldError() {
  const { openToaster } = useLayoutStore();

  const fieldError = ref<string>('');
  const fieldErrorEffect = ref<string>('');

  async function setFieldError(field: string, message: string) {
    fieldError.value = field;
    fieldErrorEffect.value = field;

    openToaster({
      message,
      type: 'error',
    });

    await sleep(500);

    fieldErrorEffect.value = '';
  }

  return {
    fieldError,
    fieldErrorEffect,
    setFieldError,
  };
}
